// import React from 'react';
// import { Edit2, Key, TabletSmartphone, Trash2, Fingerprint } from 'lucide-react';

// const UserCard = ({
//   user,
//   isSelected,
//   onSelect,
//   onClick,
//   onUpdate,
//   onDelete,
//   onEnroll,
//   onSetPassword,
//   onEnrollToDeviceClick,
//   userRole,
//   getStatusBadge
// }) => {
//   // FIXED: Wrapper functions to properly handle events
//   const handleSelect = (e) => {
//     e.stopPropagation();
//     onSelect(e, user._id);
//   };

//   const handleUpdate = (e) => {
//     e.stopPropagation();
//     e.preventDefault();
//     onUpdate(e, user);
//   };

//   const handleSetPassword = (e) => {
//     e.stopPropagation();
//     e.preventDefault();
//     onSetPassword(e, user);
//   };

//   const handleEnroll = (e) => {
//     e.stopPropagation();
//     e.preventDefault();
//     onEnroll(e, user);
//   };

//   const handleTemplate = (e) => {
//     e.stopPropagation();
//     e.preventDefault();
//     if (onEnrollToDeviceClick) {
//       onEnrollToDeviceClick(e, user);
//     }
//   };

//   const handleDelete = (e) => {
//     e.stopPropagation();
//     e.preventDefault();
//     onDelete(user, null, 'DeleteUser', e);
//   };

//   return (
//     <div
//       onClick={() => onClick(user)}
//       className={`p-4 transition-colors border cursor-pointer rounded-xl hover:bg-blue-950/40 ${
//         isSelected ? 'bg-red-900/15 border-red-700/50' : 'bg-richblue-800/20 border-blue-700/60'
//       }`}
//     >
//       <div className="flex items-start justify-between gap-3 mb-3">
//         <div className="flex items-center min-w-0 gap-3" onClick={(e) => e.stopPropagation()}>
//           <input
//             type="checkbox"
//             checked={isSelected}
//             onChange={handleSelect}
//             className="flex-shrink-0 w-4 h-4 text-red-500 border-blue-700 rounded cursor-pointer bg-richblue-900 focus:ring-red-600/50"
//           />
//           <div className={`flex items-center justify-center flex-shrink-0 w-10 h-10 font-bold text-white border rounded-full bg-gradient-to-br from-blue-600 to-blue-800 border-blue-400/30 ${
//             isSelected ? 'ring-2 ring-red-500/60' : ''
//           }`}>
//             {user.user_name?.charAt(0)}
//           </div>
//           <div className="min-w-0">
//             <p className="font-semibold text-white truncate">{user.user_name}</p>
//             <p className="text-xs truncate text-blue-400/70">{user.user_roll}</p>
//           </div>
//         </div>
//         <span className={`flex-shrink-0 px-2 py-0.5 rounded-full text-[10px] font-semibold ${getStatusBadge(user.status)}`}>
//           {user.status}
//         </span>
//       </div>

//       <div className="grid grid-cols-2 gap-y-1.5 gap-x-3 mb-3 text-xs">
//         <div>
//           <span className="text-blue-400">Department</span>
//           <p className="text-white truncate">{user.user_department || '—'}</p>
//         </div>
//         <div>
//           <span className="text-blue-400">Manager</span>
//           <p className="text-white truncate">{user.manager_Id?.manager_name || 'N/A'}</p>
//         </div>
//         <div>
//           <span className="text-blue-400">Devices</span>
//           <p className="text-white">{user.devices?.length || 0} device(s)</p>
//         </div>
//         <div>
//           <span className="text-blue-400">Enroll ID</span>
//           <p className="font-mono text-xs text-white truncate">
//             {user.devices && user.devices.length > 0 
//               ? user.devices.map(d => d.enrollment_id).filter(id => id).join(', ') 
//               : '—'}
//           </p>
//         </div>
//       </div>

//       <div className="flex flex-wrap gap-2 pt-2 border-t border-blue-800/40" onClick={(e) => e.stopPropagation()}>
//         <button
//           onClick={handleUpdate}
//           className="flex items-center justify-center flex-1 gap-1 px-1 py-1.5 text-xs font-medium text-yellow-300 transition-colors border rounded-lg bg-yellow-600/15 hover:bg-yellow-600/30 border-yellow-700/50"
//         >
//           <Edit2 className="w-3.5 h-3.5" /> Edit
//         </button>
        
//         {userRole === 'Manager' && (
//           <button
//             onClick={handleSetPassword}
//             className="flex items-center justify-center flex-1 gap-1 px-1 py-1.5 text-xs font-medium text-blue-200 transition-colors border rounded-lg bg-blue-600/15 hover:bg-blue-600/30 border-blue-700/50"
//           >
//             <Key className="w-3.5 h-3.5" /> Password
//           </button>
//         )}
        
//         <button
//           onClick={handleEnroll}
//           className="flex items-center justify-center flex-1 gap-1 px-1 py-1.5 text-xs font-medium text-green-300 transition-colors border rounded-lg bg-green-600/15 hover:bg-green-600/30 border-green-700/50"
//         >
//           <TabletSmartphone className="w-3.5 h-3.5" /> Enroll
//         </button>

//         {onEnrollToDeviceClick && (
//           <button
//             onClick={handleTemplate}
//             className="flex items-center justify-center flex-1 gap-1 px-1 py-1.5 text-xs font-medium text-purple-300 transition-colors border rounded-lg bg-purple-600/15 hover:bg-purple-600/30 border-purple-700/50"
//           >
//             <Fingerprint className="w-3.5 h-3.5" /> Template
//           </button>
//         )}
        
//         <button
//           onClick={handleDelete}
//           className="flex items-center justify-center flex-1 gap-1 px-1 py-1.5 text-xs font-medium text-red-300 transition-colors border rounded-lg bg-red-600/15 hover:bg-red-600/30 border-red-700/50"
//         >
//           <Trash2 className="w-3.5 h-3.5" /> Delete
//         </button>
//       </div>
//     </div>
//   );
// };

// export default UserCard;


import React from 'react';
import { Edit2, Key, TabletSmartphone, Trash2, Fingerprint } from 'lucide-react';

const UserCard = ({
  user,
  isSelected,
  onSelect,
  onClick,
  onUpdate,
  onDelete,
  onEnroll,
  onSetPassword,
  onEnrollToDeviceClick,
  userRole,
  getStatusBadge,
  theme
}) => {
  const isDark = theme === 'dark';

  // Theme-aware classes
  const cardBg = isSelected 
    ? (isDark ? 'bg-red-900/15 border-red-700/50' : 'bg-red-50 border-red-300')
    : (isDark ? 'bg-richblue-800/20 border-blue-700/60' : 'bg-gray-100/50 border-gray-300');
  
  const cardHover = isDark ? 'hover:bg-blue-950/40' : 'hover:bg-gray-200/50';
  const borderTop = isDark ? 'border-blue-800/40' : 'border-gray-300';
  const borderCheckbox = isDark ? 'border-blue-700' : 'border-gray-300';
  const bgCheckbox = isDark ? 'bg-richblue-900' : 'bg-white';
  const focusRing = isDark ? 'focus:ring-red-600/50' : 'focus:ring-red-500';
  
  const textPrimary = isDark ? 'text-white' : 'text-gray-900';
  const textSecondary = isDark ? 'text-blue-400/70' : 'text-gray-600';
  const textMuted = isDark ? 'text-blue-400' : 'text-gray-500';
  const textGray = isDark ? 'text-white' : 'text-gray-700';
  const textDevice = isDark ? 'text-white' : 'text-gray-800';
  
  const ringSelected = isSelected ? (isDark ? 'ring-2 ring-red-500/60' : 'ring-2 ring-red-400') : '';
  
  const bgAvatar = isDark 
    ? 'bg-gradient-to-br from-blue-600 to-blue-800 border-blue-400/30'
    : 'bg-gradient-to-br from-blue-500 to-blue-700 border-blue-400';

  // Button styles
  const editBtn = isDark
    ? 'text-yellow-300 bg-yellow-600/15 hover:bg-yellow-600/30 border-yellow-700/50'
    : 'text-yellow-700 bg-yellow-100/20 hover:bg-yellow-200/30 border-yellow-100';
  
  const passwordBtn = isDark
    ? 'text-blue-200 bg-blue-600/15 hover:bg-blue-600/30 border-blue-700/50'
    : 'text-blue-700 bg-blue-100/20 hover:bg-blue-200/30 border-blue-50';
  
  const enrollBtn = isDark
    ? 'text-green-300 bg-green-600/15 hover:bg-green-600/30 border-green-700/50'
    : 'text-green-700 bg-green-100 hover:bg-green-200 border-green-300';
  
  const templateBtn = isDark
    ? 'text-purple-300 bg-purple-600/15 hover:bg-purple-600/30 border-purple-700/50'
    : 'text-purple-700 bg-purple-100 hover:bg-purple-200 border-purple-300';
  
  const deleteBtn = isDark
    ? 'text-red-300 bg-red-600/15 hover:bg-red-600/30 border-red-700/50'
    : 'text-red-700 bg-red-100 hover:bg-red-200 border-red-300';

  // FIXED: Wrapper functions to properly handle events
  const handleSelect = (e) => {
    e.stopPropagation();
    onSelect(e, user._id);
  };

  const handleUpdate = (e) => {
    e.stopPropagation();
    e.preventDefault();
    onUpdate(e, user);
  };

  const handleSetPassword = (e) => {
    e.stopPropagation();
    e.preventDefault();
    onSetPassword(e, user);
  };

  const handleEnroll = (e) => {
    e.stopPropagation();
    e.preventDefault();
    onEnroll(e, user);
  };

  const handleTemplate = (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (onEnrollToDeviceClick) {
      onEnrollToDeviceClick(e, user);
    }
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    e.preventDefault();
    onDelete(user, null, 'DeleteUser', e);
  };

  return (
    <div
      onClick={() => onClick(user)}
      className={`p-4 transition-colors border cursor-pointer rounded-xl ${cardHover} ${cardBg}`}
    >
      <div className="flex items-start justify-between gap-3 mb-3">
        <div className="flex items-center min-w-0 gap-3" onClick={(e) => e.stopPropagation()}>
          <input
            type="checkbox"
            checked={isSelected}
            onChange={handleSelect}
            className={`flex-shrink-0 w-4 h-4 rounded cursor-pointer ${bgCheckbox} ${borderCheckbox} ${focusRing} ${
              isDark ? 'text-red-500' : 'text-red-600'
            }`}
          />
          <div className={`flex items-center justify-center flex-shrink-0 w-10 h-10 font-bold text-white border rounded-full ${bgAvatar} ${ringSelected}`}>
            {user.user_name?.charAt(0)}
          </div>
          <div className="min-w-0">
            <p className={`font-semibold ${textPrimary} truncate`}>{user.user_name}</p>
            <p className={`text-xs ${textSecondary} truncate`}>{user.user_roll}</p>
          </div>
        </div>
        <span className={`flex-shrink-0 px-2 py-0.5 rounded-full text-[10px] font-semibold ${getStatusBadge(user.status)}`}>
          {user.status}
        </span>
      </div>

      <div className="grid grid-cols-2 gap-y-1.5 gap-x-3 mb-3 text-xs">
        <div>
          <span className={textMuted}>Department</span>
          <p className={`${textGray} truncate`}>{user.user_department || '—'}</p>
        </div>
        <div>
          <span className={textMuted}>Manager</span>
          <p className={`${textGray} truncate`}>{user.manager_Id?.manager_name || 'N/A'}</p>
        </div>
        <div>
          <span className={textMuted}>Devices</span>
          <p className={textDevice}>{user.devices?.length || 0} device(s)</p>
        </div>
        <div>
          <span className={textMuted}>Enroll ID</span>
          <p className={`font-mono ${textGray} text-xs truncate`}>
            {user.devices && user.devices.length > 0 
              ? user.devices.map(d => d.enrollment_id).filter(id => id).join(', ') 
              : '—'}
          </p>
        </div>
      </div>

      <div className={`flex flex-wrap gap-2 pt-2 border-t ${borderTop}`} onClick={(e) => e.stopPropagation()}>
        <button
          onClick={handleUpdate}
          className={`flex items-center justify-center flex-1 gap-1 px-1 py-1.5 text-xs font-medium transition-colors border rounded-lg ${editBtn}`}
        >
          <Edit2 className="w-3.5 h-3.5" /> Edit
        </button>
        
        {userRole === 'Manager' && (
          <button
            onClick={handleSetPassword}
            className={`flex items-center justify-center flex-1 gap-1 px-1 py-1.5 text-xs font-medium transition-colors border rounded-lg ${passwordBtn}`}
          >
            <Key className="w-3.5 h-3.5" /> Password
          </button>
        )}
        
        <button
          onClick={handleEnroll}
          className={`flex items-center justify-center flex-1 gap-1 px-1 py-1.5 text-xs font-medium transition-colors border rounded-lg ${enrollBtn}`}
        >
          <TabletSmartphone className="w-3.5 h-3.5" /> Enroll
        </button>

        {onEnrollToDeviceClick && (
          <button
            onClick={handleTemplate}
            className={`flex items-center justify-center flex-1 gap-1 px-1 py-1.5 text-xs font-medium transition-colors border rounded-lg ${templateBtn}`}
          >
            <Fingerprint className="w-3.5 h-3.5" /> Import 
          </button>
        )}
        
        <button
          onClick={handleDelete}
          className={`flex items-center justify-center flex-1 gap-1 px-1 py-1.5 text-xs font-medium transition-colors border rounded-lg ${deleteBtn}`}
        >
          <Trash2 className="w-3.5 h-3.5" /> Delete
        </button>
      </div>
    </div>
  );
};

export default UserCard;